export default { sha: '2f6e0040bc50a15c4f26778267461ab9e3e9030c', buildNumber: 'undefined' }
